import { Form, FormFieldType } from "../Form";

export class TicketDescriptionForm extends Form {
  protected definition = {
    title: { type: FormFieldType.Text, required: true },
    description: { type: FormFieldType.Text, required: false },
    action: { type: FormFieldType.Text, required: false }
  };
}
